export default "__VITE_ASSET__B9yDo8Va__"